import React from "react";
import {IconButton, withStyles} from '@material-ui/core';

const MyButton = withStyles({
    root: {
        background: ({background}) => background ? background : "var(--orange_1)",
        "&:hover": {
            backgroundColor: ({hover}) => hover ? hover : "var(--orange_2)",
        },
        width: ({width}) => width ? width : '100%',
        height: ({height}) => height ? height : '100%'
    },
    label: {
        textTransform: 'capitalize',
        fontSize: ({fontSize}) => fontSize ? fontSize : 14,
        fontWeight: 'bold'
    }
})(IconButton)


export default function CircleIconButton(props) {
    let margin = "0px"
    if (props.margin) {
        margin = props.margin
    }
    return (<div className="clickable" style={{margin: margin}}>
            <MyButton disabled={props.disabled} className="shadow" {...props}>
                {props.icon}
                {props.text}
            </MyButton>
        </div>
    )
}